import { directive, Part } from '../../lit-html';

/**
 * Workaround for lit-html issue #877 - Values changed outside of lit-html rendering are not updated from lit-html
 * Refer to https://github.com/Polymer/lit-html/issues/877
 */
export const forceWrite = directive((value: unknown) => (part: Part) => {
	part.setValue(value);
});
